import { render, staticRenderFns } from "./hp-registration-form.vue?vue&type=template&id=1c058cdf&scoped=true&"
import script from "./hp-registration-form.ts?vue&type=script&lang=ts&"
export * from "./hp-registration-form.ts?vue&type=script&lang=ts&"
import style0 from "./hp-registration-form.scss?vue&type=style&index=0&id=1c058cdf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c058cdf",
  null
  
)

export default component.exports